module.exports = __webpack_public_path__ + "static/media/venmo-logo.597d0ff4.png";